import { ErrorInfo } from 'react';

export const reportError = async (
  componentName: string,
  error: any,
  errorInfo?: ErrorInfo
) => {
  if (process.env.NODE_ENV === 'production' && !decodeURIComponent(document.cookie).split(';').some((item) => item.trim().includes('debug=true'))) {
    return;
  }
  console.log('reportError:', { componentName, error, errorInfo });
};

export const throwAndReportError = async (
  componentName: string,
  errorMsg: string
) => {
  try {
    throw new Error(errorMsg);
  } catch (e) {
    await reportError(componentName, e);
  }
};
